import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/services/global.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { HttpService } from 'src/app/services/http.service';
import { configs } from 'src/app/configs/app.config';

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.scss']
})
export class EditProfileComponent implements OnInit {
  public errorMessage: string;
  public successMessage: string;
  public warningMessage: string;
  editProfile: FormGroup;
  constructor(private ngxService: NgxUiLoaderService, public globalService: GlobalService, private formBuilder: FormBuilder,
    public httpService: HttpService) {
    this.editProfile = this.formBuilder.group({
      firstName: [''],
      lastName: [''],
      countryCode: [''],
      email: [''],
      mobile: ['',[Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
      designation: [''],
    });
  }
  ngOnInit() {
    this.fetchUserProfile();
  }
  get f(){return this.editProfile.controls;}
  private fetchUserProfile(): void {
    this.editProfile.patchValue({

      firstName: this.globalService.userDetails['firstName'] ? this.globalService.userDetails['firstName'] : undefined,
      lastName: this.globalService.userDetails['lastName'] ? this.globalService.userDetails['lastName'] : undefined,
      email: this.globalService.userDetails['email'] ? this.globalService.userDetails['email'] : undefined,
      mobile: this.globalService.userDetails['mobile'] ? this.globalService.userDetails['mobile'] : undefined,
      designation: this.globalService.userDetails['designation'] ? this.globalService.userDetails['designation'] : undefined,
      countryCode: this.globalService.userDetails['countryCode'] ? this.globalService.userDetails['countryCode'] : '91',

    });
  }
 public isSubmitted = false;
  public UpdateUserProfile(): any {
    this.ngxService.start();
    this.isSubmitted=true;
    if(this.editProfile.valid){
    this.httpService.createPutRequest(configs['api']['updateProfile'], {
      firstName: this.editProfile['controls']['firstName']['value'] ? this.editProfile['controls']['firstName']['value'] : undefined,
      lastName: this.editProfile['controls']['lastName']['value'] ? this.editProfile['controls']['lastName']['value'] : undefined,
      email: this.editProfile['controls']['email']['value'] ? this.editProfile['controls']['email']['value'] : undefined,
      mobile: this.editProfile['controls']['mobile']['value'] ? this.editProfile['controls']['mobile']['value'] : undefined,
      designation: this.editProfile['controls']['designation']['value'] ? this.editProfile['controls']['designation']['value'] : undefined,
      countryCode: this.editProfile['controls']['countryCode']['value'] ? this.editProfile['controls']['countryCode']['value'] : undefined,

    }, '')
      .subscribe((res) => {
        this.ngxService.stop();
        this.successMessage = "Updated Successfully "
        this.globalService.userDetails = {
          firstName: this.editProfile['controls']['firstName']['value'],
          lastName: this.editProfile['controls']['lastName']['value'],
          mobile: this.editProfile['controls']['mobile']['value'],
          designation: this.editProfile['controls']['designation']['value'],
          countryCode: this.editProfile['controls']['countryCode']['value'],
          email: this.editProfile['controls']['email']['value']
        }
        setTimeout(() => {
          this.forPopupClose();
        }, 3000);
      }, (error) => {
        this.ngxService.stop();
        this.errorMessage = error && error['error'] && error.error['statusMessage'] &&
          (error.error['statusCode'] && error.error['statusCode'] !== 406) ? error.error['statusMessage'] : '';
        this.warningMessage = (error.error['statusCode'] && error.error['statusCode'] === 406) ? error.error['statusMessage'] : '';
        setTimeout(() => {
          this.errorMessage = "";
          this.warningMessage = "";
        }, 2000);
      });
    }else {
      this.ngxService.stop();
      return false;
    }
  }

  forPopupClose() {
    this.globalService.showPopUp = "";
    document.body ? document.body.classList.remove('no-scroll') : '';
  }
  forPopupOpen(key) {
    this.globalService.showPopUp = key;
    document.body ? document.body.classList.add('no-scroll') : '';
  }
}
